import { IconLockOutline18 as LockIcon } from "nucleo-ui-outline-18"

import type { ThreadLockHolder } from "@productlane/lib"
import { cn } from "@productlane/lib/src/cn"
import { Avatar, Button } from "@productlane/ui"

import { THREAD_COLUMN_PADDING } from "../thread-column"

/**
 * Replaces the composer while a teammate has the thread open, so two agents do
 * not write the same reply. The block is dismissible: the holder may have
 * stepped away, and nothing here should stop an urgent answer.
 */
export function LockedComposer({
	holder,
	onDismiss,
}: {
	holder: ThreadLockHolder
	onDismiss: () => void
}) {
	return (
		<div className="group z-1 flex w-full justify-center">
			<div
				className={cn("mx-auto w-full max-w-[50rem]", THREAD_COLUMN_PADDING)}
			>
				<div className="relative -mx-2 mb-3 mt-[0.5px] flex w-auto flex-col gap-3 rounded-2xl border border-gray-200 bg-white px-3.5 py-3.5 shadow-sm dark:border-gray-700/80 dark:bg-gray-800 dark:shadow-black">
					<div className="flex items-center gap-2.5">
						<Avatar
							image={holder.imageUrl}
							name={holder.name}
							size="xs"
							roundness="full"
						/>
						<div className="min-w-0 flex-1 text-sm">
							<span className="font-medium text-primary">{holder.name}</span>
							<span className="text-secondary"> has this thread open.</span>
						</div>
						<Button variant="outline" size="sm" onClick={onDismiss}>
							Reply anyway
						</Button>
					</div>
					<div className="flex items-center gap-2 text-xs text-tertiary">
						<LockIcon className="h-3.5 w-3.5 flex-none" />
						The reply box unlocks on its own once they close the thread.
					</div>
				</div>
			</div>
		</div>
	)
}
